import {useEffect, useState, useSyncExternalStore} from 'react';

/**
 * Subscribe to marginMarkers from EditorView.
 * Uses proper ProseMirror pattern - plugin view stores data, React subscribes.
 */
export function useMarginMarkers(view) {
    // Fallback for when view is not available
    const [fallbackState, setFallbackState] = useState({markers: [], active: null, activeReferenceUid: null});

    useEffect(() => {
        if (!view || !view.__marginMarkersView) {
            setFallbackState({markers: [], active: null, activeReferenceUid: null});
        }
    }, [view]);

    // Use React 18's useSyncExternalStore for optimal performance
    const markers = useSyncExternalStore(
        (callback) => {
            // Subscribe
            if (!view?.__marginMarkersView) return () => {
            };

            view.__marginMarkersView.listeners.add(callback);

            // Unsubscribe
            return () => {
                view.__marginMarkersView?.listeners.delete(callback);
            };
        },
        () => {
            // Get snapshot
            return view?.__marginMarkersView?.markers || fallbackState.markers;
        },
        () => {
            // Get server snapshot (for SSR)
            return [];
        }
    );

    const active = useSyncExternalStore(
        (callback) => {
            // Subscribe
            if (!view?.__marginMarkersView) return () => {
            };

            view.__marginMarkersView.listeners.add(callback);

            // Unsubscribe
            return () => {
                view.__marginMarkersView?.listeners.delete(callback);
            };
        },
        () => {
            // Get snapshot
            return view?.__marginMarkersView?.active || fallbackState.active;
        },
        () => {
            // Get server snapshot (for SSR)
            return null;
        }
    );

    const activeReferenceUid = useSyncExternalStore(
        (callback) => {
            if (!view?.__marginMarkersView) return () => {
            };

            view.__marginMarkersView.listeners.add(callback);

            return () => {
                view.__marginMarkersView?.listeners.delete(callback);
            };
        },
        () => {
            return view?.__marginMarkersView?.activeReferenceUid ?? fallbackState.activeReferenceUid;
        },
        () => {
            return null;
        }
    );

    return {markers, active, activeReferenceUid};
}
